import { Pipe, PipeTransform } from "@angular/core";
import { UserService } from "../services/user.service";
import * as numeral from "numeral";
import { EDecimalSeperator, EDigitGroupingSeperator } from "../models/userSettings.model";

@Pipe({
  name: "aceNumber"
})
export class AceNumberPipe implements PipeTransform {

  constructor() {
  }

  transform(numberInput: number, digitGrouping: EDigitGroupingSeperator = null, decimalSeperator: EDecimalSeperator = null, ...args: any[]): any {
    const decimals = args[0] || 0;
    let formatDecimals;
    if (decimals > 0) {
      formatDecimals = ".";
    }
    for (let i = 0; i < decimals; i++) {
      formatDecimals += "0";
    }
    const format = "0,0" + formatDecimals;
    let thousandsDelimiter = ",";
    let decimalDelimiter = ".";
    if (!digitGrouping) {
      digitGrouping = EDigitGroupingSeperator.NONE;
    }
    if (!decimalSeperator) {
      decimalSeperator = EDecimalSeperator.DOT;
    }
    if (decimalSeperator) {
      switch (decimalSeperator) {
        case EDecimalSeperator.DOT:
          decimalDelimiter = ".";
          break;
        case EDecimalSeperator.COMMA:
          decimalDelimiter = ",";
          break;
      }
    }
    if (digitGrouping) {
      switch (digitGrouping) {
        case EDigitGroupingSeperator.DOT:
          thousandsDelimiter = ".";
          break;
        case EDigitGroupingSeperator.COMMA:
          thousandsDelimiter = ",";
          break;
        case EDigitGroupingSeperator.SPACE:
          thousandsDelimiter = " ";
          break;
        case EDigitGroupingSeperator.NONE:
          thousandsDelimiter = "";
          break;
      }
    }

    numeral.localeData("en").delimiters = {
      thousands: thousandsDelimiter,
      decimal: decimalDelimiter
    };

    return numeral(numberInput).format(format);
  }

}
